import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddExamdate, successaddExamdate } from "./AddExamdateSlice";
import { PayloadAction } from "@reduxjs/toolkit";

import {
  failuredeleteExamdate,
  successdeleteExamdate,
} from "./DeleteExamdateSlice";
import { failurelistExamdate, successlistExamdate } from "./ListExamdateSlice";
import { failureEditExamdate, successEditExamdate } from "./EditExamdateSlice";
import { IExamdate } from "../../../Pages/ExamDate/IExamDate";

// list
const ListExamdateApi = () => {
  return api.get("/api/exam/exam-date");
};

export function* ListExamdateCall() {
  try {
    const response: AxiosResponse = yield call(ListExamdateApi);
    yield put(successlistExamdate(response.data));
  } catch (error) {
    yield put(failurelistExamdate(error));
  }
}

// add
const AddExamdateApi = (action: PayloadAction<IExamdate>) => {
  return api.post("/api/exam/exam-date/add", action.payload);
};

export function* AddExamdateCall(action: PayloadAction<IExamdate>) {
  try {
    const response: AxiosResponse = yield call(AddExamdateApi, action);
    yield put(successaddExamdate(response.data));
  } catch (error) {
    yield put(failureaddExamdate(error));
  }
}

// edit
const EditExamdateApi = (action: PayloadAction<IExamdate>) => {
  return api.put("/api/exam/exam-date/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditExamdateCall(action: PayloadAction<IExamdate>) {
  try {
    const response: AxiosResponse = yield call(EditExamdateApi, action);
    yield put(successEditExamdate(response.data));
  } catch (error) {
    yield put(failureEditExamdate(error));
  }
}

// delete
const DeleteExamdateApi = (action: PayloadAction<number>) => {
  return api.delete("/api/exam/exam-date/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteExamdateCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteExamdateApi, action);
    yield put(successdeleteExamdate(response.data));
  } catch (error) {
    yield put(failuredeleteExamdate(error));
  }
}
